import { render } from "./NavBlock.vue?vue&type=template&id=e6b520d6&scoped=true"
import script from "./NavBlock.vue?vue&type=script&lang=js"
export * from "./NavBlock.vue?vue&type=script&lang=js"

import "./../../assets/styles/admin/navigation.scss?vue&type=style&index=0&id=e6b520d6&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6b520d6"]])

export default __exports__